import React, { useEffect, useRef } from 'react';
import { Spinner } from '../components/ui';
import { initiateGoogleOAuth } from '../utils/googleOAuth';

/**
 * OAuth initiation page - automatically redirects to Google OAuth
 * Used for direct linking from marketing website
 */
const GoogleOAuthStart = () => {
    const hasInitiatedRef = useRef(false);

    useEffect(() => {
        // Prevent double initiation
        if (hasInitiatedRef.current) {
            console.log('OAuth already initiated, skipping');
            return;
        }

        // Auto-initiate OAuth on page load
        try {
            hasInitiatedRef.current = true;
            console.log('Auto-initiating Google OAuth from direct link');
            initiateGoogleOAuth();
        } catch (error) {
            console.error('Error initiating Google OAuth:', error);
            // Fallback to register page if OAuth fails
            window.location.href = '/register';
        }
    }, []);

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-2 dark:bg-boxdark-2">
            <div className="text-center space-y-4">
                <Spinner size="xl" />
                <p className="text-lg text-black dark:text-white">
                    Connecting to Google...
                </p>
                <p className="text-sm text-body dark:text-bodydark">
                    Please wait while we redirect you to Google Sign-In
                </p>
            </div>
        </div>
    );
};

export default GoogleOAuthStart;
